(function ($) {
	//https://themergency.com/an-alternative-to-jquerys-getscript-function.html
	$.initLoadScript = function (url, arg1, arg2) {
		function isFunction(func) {
			return typeof func === "function";
		}
		var cache = false,
			callback = null;
		//arg1 and arg2 can be interchangable
		if (isFunction(arg1)) {
			callback = arg1;
			cache = arg2 || cache;
		} else {
			cache = arg1 || cache;
			callback = arg2 || callback;
		}
		var load = true;
		//check all existing script tags in the page for the url
		$('script[type="text/javascript"]').each(function () {
			return (load = url != $(this).attr("src"));
		});
		if (load) {
			//didn't find it in the page, so load it
			$.ajax({
				type: "GET",
				url: url,
				success: callback,
				dataType: "script",
				cache: cache,
			});
		} else {
			//already loaded so just call the callback
			if (isFunction(callback)) {
				callback.call(this);
			}
		}
	};

	var win = $(window),
		prev_width = win.width(),
		prev_height = win.height();
	win.on("resize", function () {
		var width = win.width(),
			height = win.height();

		if (width !== prev_width) {
			win.trigger("hresize");
		}
		if (height !== prev_height) {
			win.trigger("vresize");
		}

		prev_width = width;
		prev_height = height;
	});

	const tooltipTriggerList = document.querySelectorAll(
		'[data-bs-toggle="tooltip"]'
	);
	const tooltipList = [...tooltipTriggerList].map(
		(tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl)
	);

	initVHunits();

	$(document).on("ready", function () {
		initNav();
		wrapTablesAndSetShadows();
	});
	$(window).on("load", function () {});
	$(window).on("hresize", function () {});
	$(window).on("vresize", function () {
		initVHunits();
	});
	$(window).on("resize", function () {});

	function initVHunits() {
		let vh = window.innerHeight * 0.01;
		let win_height = window.innerHeight;
		document.documentElement.style.setProperty("--vh", `${vh}px`);
		document.documentElement.style.setProperty("--win_h", `${win_height}px`);
	}

	function initNav() {
		var $nav = $(".navbar.fixed-top");
		if ($(window).scrollTop() >= 5) {
			$nav.addClass("scrolled");
		}
		$(document).on("scroll", function () {
			$nav.toggleClass("scrolled", $(this).scrollTop() > 5);
		});

		var navbarNavOffcanvas = document.getElementById("navbarNavOffcanvas");
		navbarNavOffcanvas.addEventListener("show.bs.offcanvas", function () {
			$("#main-nav").addClass("canvas_open");
		});
		navbarNavOffcanvas.addEventListener("hide.bs.offcanvas", function () {
			$("#main-nav").removeClass("canvas_open");
		});

		$(document).on("click", ".header_search_btn", function () {
			document.getElementById("header_search").focus();
		});
	}

	// Wrap each table with a wrapper and set its shadows
	function wrapTablesAndSetShadows() {
		$(".wp-block-table").each(function () {
			$(this).wrap('<div class="table_wrap"></div>');
			setContainerScroll($(this));
		});
	}

	// Set shadows when the window is resized
	$(window).on("resize", function () {
		$(".wp-block-table").each(function () {
			setContainerScroll($(this));
		});
	});

	// Set shadows when the table is scrolled
	$(".wp-block-table").on("scroll", function () {
		setContainerScroll($(this));
	});

	// Set shadows based on container scroll position
	function setContainerScroll($container) {
		var $this = $container;
		var scrollLeft = $this.scrollLeft();
		var maxScrollWidth = $this.innerWidth();
		var maxScrollAmt = $this.find("table").prop("scrollWidth") - maxScrollWidth;
		var $tableWrap = $this.closest(".table_wrap");

		$tableWrap.toggleClass("scrolled-right", scrollLeft >= maxScrollAmt);
		$tableWrap.toggleClass("scrolled-left", scrollLeft > 0);
	}
})(jQuery);

//ajax
let loadPostsHasRunOnce = false;
function loadNextPosts(args, section) {
	if (typeof section === "undefined") {
		section = document;
	}
	const container = section.querySelector(".load-more-container");
	const noPostsElement = section.querySelector(".no-posts");
	const loadMoreButton = section.querySelector(".load-more-button");
	const spinner = section.querySelector(".spinner");
	args["paged"]++;
	const params = new FormData();
	params.append("action", "load_posts");
	Object.keys(args).forEach(function (key) {
		params.append(key, args[key]);
	});
	const options = {
		method: "GET",
		credentials: "same-origin",
		//body: params
	};
	var ajax_url =
		"/wp-admin/admin-ajax.php?" + new URLSearchParams(params).toString();
	loadMoreButton.style.display = "none";
	spinner.classList.remove("d-none");
	noPostsElement.classList.replace("d-block", "d-none");
	//killAllScrollTriggers();
	fetch(ajax_url, options)
		.then((response) => response.json())
		.then((response) => {
			spinner.classList.add("d-none");
			if (response.success) {
				container.insertAdjacentHTML("beforeend", response.data.html);
				if (response.data.more_posts) {
					loadMoreButton.style.display = "block";
				}
			} else {
				noPostsElement.classList.replace("d-none", "d-block");
				loadMoreButton.style.display = "none";
			}
		});
}

function loadPosts(args, section, callback) {
	setArgsWithQueryString(args);

	section = section || document;
	const container = section.querySelector(".load-more-container");
	const noPostsElement = section.querySelector(".no-posts");
	const loadMoreButton = section.querySelector(".load-more-button");
	const spinner = section.querySelector(".spinner");
	const selectsContainer = document.querySelector(".selects_wrapper");
	jQuery(selectsContainer)
		.css({ opacity: "0.5" })
		.find("select")
		.prop("disabled", true); //disable selects
	args["paged"] = 1;
	const params = new FormData();
	params.append("action", "load_posts");
	Object.keys(args).forEach(function (key) {
		params.append(key, args[key]);
	});
	const options = {
		method: "GET",
		credentials: "same-origin",
		//body: params
	};
	var ajax_url =
		"/wp-admin/admin-ajax.php?" + new URLSearchParams(params).toString();
	jQuery(container).slideFadeToggle(function () {
		container.innerHTML = "";
		if (spinner) {
			spinner.classList.remove("d-none");
		}
		if (noPostsElement) {
			noPostsElement.classList.replace("d-block", "d-none");
		}
		if (loadMoreButton) {
			loadMoreButton.style.display = "none";
		}

		fetch(ajax_url, options)
			.then((response) => response.json())
			.then((response) => {
				if (spinner) {
					spinner.classList.add("d-none");
				}

				if (response.success) {
					if (response.data.filters_html) {
						const selectedOptions = jQuery(".selects_wrapper select")
							.map(function () {
								return this.selectedOptions[0];
							})
							.get();
						selectsContainer.outerHTML = response.data.filters_html;
						jQuery(".select_wrapper").each(function (index, el) {
							if (el.firstElementChild.name == "sort") {
								jQuery(el).find("select").val(selectedOptions[index].value);
							}
							if (el.firstElementChild.name == "filter") {
								if (selectedOptions[index].dataset.value) {
									jQuery(el)
										.find(
											'option[data-value="' +
												selectedOptions[index].dataset.value +
												'"]'
										)
										.prop("selected", "selected");
								}
							}
						});
					}
					container.innerHTML = response.data.html;

					jQuery(container).slideFadeToggle();
					if (response.data.more_posts) {
						if (loadMoreButton) {
							loadMoreButton.style.display = "block";
						}
					}
					jQuery(selectsContainer)
						.css({ opacity: "1" })
						.find("select")
						.prop("disabled", false);
				} else {
					jQuery(container).slideFadeToggle();
					if (noPostsElement) {
						noPostsElement.classList.replace("d-none", "d-block");
					}
					if (loadMoreButton) {
						loadMoreButton.style.display = "none";
					}
					jQuery(selectsContainer)
						.css({ opacity: "1" })
						.find("select")
						.prop("disabled", false);
				}
				if (callback) {
					callback(response.data);
				}
				initMobileFilters();
				setFilterSelectsWithQueryString(args);
				loadPostsHasRunOnce = true;
			});
	});
}

const updateArgs = (args) => {
	// change tax/meta from json string to array for manipulation below
	if (args["tax_query"]) {
		args["tax_query"] = JSON.parse(args["tax_query"]);
	}
	if (args["meta_query"]) {
		args["meta_query"] = JSON.parse(args["meta_query"]);
	}
	const selects = document.querySelectorAll(".selects_wrapper select");
	//loop over each select element and update the associated arg
	for (let index = 0; index < selects.length; index++) {
		// set the order and orderby args if select[name="sort"] exists
		if (selects[index].name == "sort") {
			args["order"] = selects[index].selectedOptions[0].dataset.order;
			args["orderby"] = selects[index].selectedOptions[0].dataset.orderby;
		}
		if (selects[index].name == "filter") {
			// Select is tax query. Remove from args. Will be added below
			if (
				selects[index].dataset.type == "tax_query" &&
				args[selects[index].dataset.type]
			) {
				args[selects[index].dataset.type] = args[
					selects[index].dataset.type
				].filter(
					(taxQuery) =>
						taxQuery.taxonomy != selects[index].selectedOptions[0].dataset.key
				);
			}
			// Select is meta query. Remove from args. Will be added below
			if (
				selects[index].dataset.type == "meta_query" &&
				args[selects[index].dataset.type]
			) {
				args[selects[index].dataset.type] = args[
					selects[index].dataset.type
				].filter(
					(metaQuery) =>
						metaQuery.key != selects[index].selectedOptions[0].dataset.key
				);
			}
			//remove from args non meta/tax args if the value is ""
			if (selects[index].value == "") {
				if (
					selects[index].dataset.type != "tax_query" &&
					selects[index].dataset.type != "meta_query"
				) {
					let argsType = selects[index].dataset.type;
					delete args[argsType];
				}
			}

			if (selects[index].value != "") {
				//this select has a value
				//select is not meta/tax query
				if (
					selects[index].dataset.type != "tax_query" &&
					selects[index].dataset.type != "meta_query"
				) {
					//update the args object
					args[selects[index].dataset.type] =
						selects[index].selectedOptions[0].dataset.value;
				}
				//add this select's data-values to tax_query
				if (selects[index].dataset.type == "tax_query") {
					args["tax_query"] = args["tax_query"] || [];
					args["tax_query"].push({
						taxonomy: selects[index].selectedOptions[0].dataset.key,
						field: "term_id",
						terms: selects[index].selectedOptions[0].dataset.value,
					});
				}
				//add this select's data-values to meta_query
				if (selects[index].dataset.type == "meta_query") {
					args["meta_query"] = args["meta_query"] || [];
					args["meta_query"].push({
						key: "author",
						value: selects[index].selectedOptions[0].dataset.value,
						compare: "LIKE",
					});
				}
				//add this select's data-values to date_query
				if (selects[index].dataset.type == "date_query") {
					args["date_query"] = [
						{
							year: selects[index].selectedOptions[0].dataset.value,
						},
					];
				}
			} else {
				//this select has no value
			}
		}
	}

	/*************** Build the new url ***************/
	const isSearch = document.body.classList.contains("search");
	let url = new URL(window.location);
	let params = new URLSearchParams(isSearch ? `s=${args.s}` : "");
	//desctructure args.  "rest" will contain the needed params
	const {
		ep_ajax,
		ep_integrate,
		filters,
		post_status,
		template,
		posts_per_page,
		post__not_in,
		...rest
	} = args;

	Object.entries(rest).forEach((param) => {
		if (param[0] == "s") {
			return;
		}
		if (typeof param[1] === "string") {
			params.set(`filter-${param[0]}`, param[1]);
		} else if (param[0] == "date_query") {
			params.set("filter-year", param[1][0]["year"]);
		} else if (param[0] == "tax_query") {
			param[1].forEach((item) => {
				params.set(`filter-${item.taxonomy}`, item.terms);
			});
		} else if (param[0] === "meta_query") {
			param[1].forEach((item) => {
				if (item.key && item.key == "author") {
					params.set("filter-author", item.value);
				} else {
					params.set(`filter-${item.key}`, item.value);
				}
			});
		}
	});
	//set the new query string
	url.search = params.toString();
	history.replaceState(null, null, url);

	/*************** end Build the new url ***************/

	//change tax/meta/date queries back to json string
	if (args["tax_query"]) {
		args["tax_query"] = JSON.stringify(args["tax_query"]);
	}
	if (args["meta_query"]) {
		args["meta_query"] = JSON.stringify(args["meta_query"]);
	}
	if (args["date_query"]) {
		args["date_query"] = JSON.stringify(args["date_query"]);
	}
};

jQuery.fn.slideFadeToggle = function (speed, easing, callback) {
	return this.animate(
		{ opacity: "toggle", height: "toggle" },
		speed,
		easing,
		callback
	);
};

window.initFitVids = function () {
	// this fitvids resizes all youtube and vimeo iframes and makes them responsive
	$("#main_body_wrapper").fitVids();
};

document.querySelectorAll(".lazy-load-video").forEach((item) => {
	item.addEventListener("click", (e) => {
		item.firstElementChild.innerHTML = item.dataset.embed;
		item.classList.add("video_active");
		let iframe = item.querySelector("iframe");
		let mediaLibraryVideo = e.currentTarget.querySelector(
			".wp-video-shortcode"
		);
		if (iframe) {
			iframe.src = iframe.src + "&autoplay=1";
		}
		if (mediaLibraryVideo) {
			mediaLibraryVideo.play();
		}
	});
});

function debounce(func) {
	var timer;
	return function (event) {
		if (timer) clearTimeout(timer);
		timer = setTimeout(func, 100, event);
	};
}
